import type { Notification } from "../../../shared/models/notification";
import { createDataStore } from "../lib/data_store";

const notificationStore = createDataStore<Notification[] | undefined>();

export const useNotifications = notificationStore.useDataSuspense;

const defaultNotifications: Notification[] = [
  {
    id: "notif-expiring-webhook",
    name: "Expiring Certificate Alert",
    trigger: "expiring",
    hooks: [
      {
        type: "webhook",
        endpoint: "https://hooks.example.com/cert-expiring",
        enabled: true,
      },
    ],
    createdAt: new Date().toISOString(),
    enabled: true,
  },
  {
    id: "notif-revoked-sns",
    name: "Revoked Certificate Notification",
    trigger: "revoked",
    hooks: [
      {
        type: "amazon_sns",
        endpoint: "arn:aws:sns:us-east-1:123456789:cert-revoked",
        enabled: true,
      },
    ],
    createdAt: new Date().toISOString(),
    enabled: true,
  },
];

export function initNotifications(): void {
  const current = notificationStore.getData();
  if (current === undefined) {
    notificationStore.setData(defaultNotifications);
  }
}

export function addNotification(data: {
  name: string;
  trigger: Notification["trigger"];
  hooks: Notification["hooks"];
}): Notification {
  const notification: Notification = {
    ...data,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
    enabled: true,
  };
  notificationStore.updateData((current) => [...(current ?? []), notification]);
  return notification;
}

export function toggleNotification(id: string): void {
  notificationStore.updateData((current) =>
    (current ?? []).map((n) =>
      n.id === id ? { ...n, enabled: !n.enabled } : n
    )
  );
}

export function deleteNotification(id: string): void {
  notificationStore.updateData((current) =>
    (current ?? []).filter((n) => n.id !== id)
  );
}
